<template>
  <div>
    <!--<section
      @click="onClickHandler"
      id="sectionId"
      :onmouseover="exitmenu()"
      style="
        background-image: url('https://CMS.e2m.live/write/BrandingImage/BackGround/908326ac-691b-43c8-8995-3597e94a5b7d.jpg');
      "
      class="d-flex body-content new-addendee-list"
    >-->
    <section
      @click="onClickHandler"
      id="sectionId"
      :onmouseover="exitmenu()"
      style="background-color: #f1f3f4"
      :class="
        isAdminComponent
          ? 'self-service-speaker-wrap d-flex body-content new-addendee-list self-service-pad-wrap'
          : 'd-flex body-content new-addendee-list'
      "
    >
      <div class="container-fluid spe_list">
        <!--------search end------>
        <div class="row">
          <div
            class="col-md-4 col-lg-6 mb-md-3 d-flex align-items-center position-relative"
          >
            <h1
              id="headerText"
              :class="{
                'page-head text-uppercase mb-0 mt-lg-3': true,
                'd-none': attendeeData.length == 0 && isAdminComponent,
              }"
            >
              <v-autocomplete
                style="background: white"
                v-if="$route.path.includes('mainlobby')"
                dense
                outlined
                v-model="speakerEvent"
                :items="$store.state.MappedEvent"
                prepend-inner-icon="search"
                return-object
                hide-details
                label="Select Event"
                item-text="EventFullName"
              ></v-autocomplete>
              <template v-else-if="!isRegistrationComponent">{{
                headerText
              }}</template>
            </h1>
            <!-- mobile search button -->
            <div class="d-block d-md-none">
              <button
                class="mob_search_button"
                v-on:click="mob_spelist_search()"
              >
                <img
                  src="../assets/Images/icons/search-black.svg"
                  alt="e2m"
                  width="20px"
                />
              </button>
            </div>
            <!-- mobile search button end -->
          </div>
          <div class="col-md-8 col-lg-6 mob-py-0">
            <div class="row justify-content-end mob-colrev my-3 my-md-0">
              <div
                v-if="ShowFilter"
                class="col-md-4 mb-md-3 pl-md-1 comm-width-fillter-new"
              >
                <div class="position-relative fixed-w full-width filter-hld">
                  <!-- <select v-on:change="onChange($event)">
                <options
                  v-for="group in spkFilterData"
                  v-bind:key="group.id"
                  :value="group.id"
                  data-tag="roundtableFilter"
                >{{group.GroupName}}</options>

             
                  </select>-->

                  <select v-on:change="onChange($event)">
                    <option
                      v-for="group in spkFilterData"
                      v-bind:key="group.id"
                      :value="group.id"
                      data-tag="roundtableFilter"
                    >
                      {{ group.GroupName }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-8 mb-md-3 mob-py-0">
                <div class="right-search-hld" id="mob_spe_search">
                  <div
                    v-if="ShowSearch"
                    class="position-relative fixed-w full-width search-hld"
                  >
                    <form
                      id="newsletter-validate-detail"
                      action
                      method
                      class="form subscribe"
                    >
                      <!-- <input
                      id="InputSearch"
                      type="text"
                      @keyup="searchAttendee"
                      v-model="searchtext"
                      placeholder="Search by Name, Company, Title or keywords...  "
                    />-->

                      <input
                        id="InputSearch"
                        type="text"
                        @keyup="searchAttendee2"
                        v-on:keydown.enter.prevent="searchAttendee"
                        v-model="searchtext"
                        placeholder="Search by Name, Company, Title, Keywords and click on Go"
                      />
                    </form>
                    <div class="reset-search-btn">
                      <p
                        v-if="searchtext"
                        @click="
                          searchtext = '';
                          searchAttendee();
                        "
                      >
                        <v-icon dark small color="#8a8a8a">mdi-close</v-icon>
                      </p>
                    </div>
                  </div>
                  <a
                    href="javascript:void(0);"
                    @click="searchAttendee"
                    v-if="ShowSearch"
                    >GO</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!---Speaker intro screen start--->
        <div
          class="blank-expo-section"
          v-if="attendeeData.length == 0 && isAdminComponent"
        >
          <img src="../assets/Images/self-service/speaker-add.png" />
          <h3 class="mt-3">Add Speakers</h3>
          <p class="mt-3">
            Adding Speakers brings more structure and makes the event more
            informative to the attendees. Once the Speaker profile has been
            saved, it will automatically be displayed in the speaker section of
            the event page and inside the session details.
          </p>
          <v-btn
            dark
            color="#1a73e8"
            class="save-standard mt-3"
            @click="openAddNewSpeakerPopup()"
            ><v-icon size="20px" color="#ffffff">mdi-plus</v-icon> Add New
            Speaker</v-btn
          >
        </div>
        <!---attendee intro screen end--->
        <!--------search------>
        <!------top area start--->
        <div id="dvAttendeeWrapper" class="row attendee-list-box-wrapper">
          <!--add attendee start--->
          <!-- <div
            v-if="isAdminComponent"
            class="col-6 col-md-6 col-lg-3 col-elg-2 spe_listwrap"
            @click="OpenAddSpeakerPopup"
          >
            <div class="attendee-box-hld f-center ss-add-plus-box">
              <a>
                <img src="../assets/Images/icons/add-new-blue.svg" alt="e2m" />
                <h3>Add Speaker</h3>
              </a>
            </div>
          </div> -->

          <!---add attendee end-->
          <!----attendee box start---->

          <div
            v-for="attendee in attendeeData"
            v-bind:key="attendee.id"
            v-on:click="
              openModal(
                attendee.id,
                attendee.Name,
                attendee.Company,
                attendee.Designation,
                attendee.Image,
                attendee.Profile,
                attendee.Initials,
                attendee.SocialLinks,
                attendee.Resources,
                attendee.Email,
                attendee
              )
            "
            :class="
              isAdminComponent
                ? 'speaker-list-self-service mb-2 mb-md-0 p-md-0 p-lg-0 col-12 col-md-12 col-lg-12 col-elg-12'
                : 'mb-2 mb-md-8 col-6 col-md-6 col-lg-3 col-elg-2 spe_listwrap'
            "
            v-show="!attendee.HideInList || isAdminComponent"
          >
            <div
              class="attendee-box-hld position-relative"
              :data-tag="'speaker/' + attendee.id + '/' + attendee.Name"
              @mouseover="
                getBookmarkStatus(
                  attendee.id,
                  attendee.Name,
                  attendee.Image,
                  attendee.isBookmarked,
                  attendee.isLoading
                )
              "
            >
              <v-badge
                color="white"
                bottom
                class="attendee-box-badge"
                v-if="
                  !isAdminComponent && attendee && loggedInUseID != attendee.id
                "
              >
                <template #badge>
                  <div v-if="!attendee.isBookmarked">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          size="32"
                          color="black"
                          @click.stop="
                            addAttendeeBookMark(
                              attendee.id,
                              attendee.Name,
                              attendee.Image,
                              attendee.isBookmarked,
                              $event
                            )
                          "
                          style="cursor: pointer"
                          v-on="on"
                          data-analytics
                          data-page-name="/attendee"
                          data-action="click"
                          :data-action-label="
                            'AddedNewBookmark: ' + attendee.Name
                          "
                          >bookmark_border</v-icon
                        >
                      </template>
                      <span>Bookmark</span>
                    </v-tooltip>
                  </div>

                  <div v-else>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          size="32"
                          color="success"
                          data-analytics
                          data-page-name="/attendee"
                          data-action="click"
                          :data-action-label="
                            'RemoveNewBookmark: ' + attendee.Name
                          "
                          @click="
                            addAttendeeBookMark(
                              attendee.id,
                              attendee.Name,
                              attendee.Image,
                              attendee.isBookmarked,
                              $event
                            )
                          "
                          style="cursor: pointer"
                          >bookmark</v-icon
                        ></template
                      >
                      <span>Bookmarked</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-badge>
              <div
                class="left-grid speaker-left-grid"
                data-toggle="modal"
                :data-target="isRegistrationComponent ? '' : '#myModal2'"
              >
                <div class="attendee-presence-status position-relative">
                  <span
                    :class="
                      attendee.isOnline
                        ? 'attendee-status-bubble  attendee-online-status'
                        : 'attendee-status-bubble  attendee-off-online-status'
                    "
                  ></span>
                  <div
                    v-if="
                      attendee.Image !== undefined && attendee.Image.length > 0
                    "
                    class="attendee-img-hld mx-0 mx-md-auto mx-sm-auto"
                    :data-tag="'speaker/' + attendee.id + '/' + attendee.Name"
                  >
                    <img
                      v-bind:src="attendee.Image"
                      v-bind:alt="attendee.Name"
                      @error="attendee.Image = ''"
                    />
                  </div>

                  <div
                    v-else
                    :data-tag="'speaker/' + attendee.id + '/' + attendee.Name"
                    class="attendee-img-hld mx-0 mx-md-auto mx-sm-auto"
                  >
                    {{ attendee.Initials }}
                  </div>
                </div>
                <div
                  class="attendee-des-hld"
                  :data-tag="'speaker/' + attendee.id + '/' + attendee.Name"
                >
                  <input type="hidden" id="senderId" v-model="attendee.id" />
                  <h3
                    :data-tag="'speaker/' + attendee.id + '/' + attendee.Name"
                  >
                    {{ attendee.Name }}
                  </h3>
                  <p :data-tag="'speaker/' + attendee.id + '/' + attendee.Name">
                    {{ attendee.Company }}
                  </p>
                  <p :data-tag="'speaker/' + attendee.id + '/' + attendee.Name">
                    {{ attendee.Designation }}
                  </p>
                </div>
              </div>
              <!--middle start--->
              <div
                class="center-grid speaker-center-grid"
                v-if="isAdminComponent"
              >
                <div class="attendee-status-switch">
                  <p><strong>Status</strong></p>
                  <v-switch
                    v-model="attendee.IsPublished"
                    color="primary"
                    @change="
                      $parent.updateSpeakerData({
                        SpeakerId: attendee.id,
                        IsPublished: attendee.IsPublished,
                      })
                    "
                  ></v-switch>
                </div>
              </div>
              <!--middle end--->
              <!--last start--->
              <div
                class="right-grid speaker-right-grid"
                v-if="isAdminComponent"
              >
                <!-- <div class="copy-link-spe">
                  <v-icon color="#333333" size="25px">mdi-content-copy</v-icon>  Copy magic link
                </div>
                <div class="share-spe">
                  <v-icon color="#333333" size="25px">mdi-share</v-icon> Share
                </div> -->

                <div class="attendee-edit-dlt">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        small
                        icon
                        class="mr-3"
                        @click="
                          currentAttendee = attendee;
                          editCurrentSpeaker();
                        "
                        ><img src="../assets/Images/self-service/edit-self.svg"
                      /></v-btn>
                    </template>
                    <span class="v-tooltip-content v-tooltip-bottom"
                      >Edit Speaker</span
                    >
                  </v-tooltip>

                  <!-- <v-btn small icon><img src="../assets/Images/self-service/delete-self.svg"/></v-btn> -->
                </div>
              </div>
              <!--last end--->
            </div>
          </div>
          <!----attendee box end---->
        </div>
        <!-- No dat Found -->
        <div v-show="IsShowNoDataFound" style="text-align: center">
          <h2 style="text-align: center; margin-top: 60px">
            {{ $t("speaker.nodata") }}
          </h2>
          <!-- <button
            id="btnNewSearch"
            v-on:click="cancelSearch()"
            class="blue-button"
            type="button"
            style="text-align:center;margin-top: 60px;"
            data-tag="attendeeNewSearch"
          >Start new search</button>-->
        </div>

        <!-- No dat Found ENDS-->
      </div>
    </section>
    <!----------right attendee detail-------->
    <!-- Modal -->
    <div
      class="modal right fade speakers-popup"
      id="myModal2"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel2"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body new-addendee-list new-addendee-details p-0">
            <div class="attendee-admin-edit-menu" v-if="isAdminComponent">
              <ul>
                <li class="final-button small-font">
                  <!-- <v-btn color="#000000" text
                    ><v-icon color="#000000" size="20px" class="mr-1"
                      >mdi-trash-can-outline</v-icon
                    >
                    Delete</v-btn
                  > -->
                </li>
                <li>
                  <!-- <div class="admin-attendee-status">
                    <label>Status</label>
                    <v-switch v-model="switch18" color="#1a73e8"></v-switch>
                  </div> -->
                </li>
                <li class="small-font">
                  <v-btn
                    @click="editCurrentSpeaker()"
                    color="#1a73e8"
                    dark
                    width="152px"
                    height="40px"
                    class="save-standard"
                    ><v-icon color="#ffffff" size="20px" class="mr-1"
                      >mdi-pencil-outline</v-icon
                    >
                    Edit Speaker</v-btn
                  >
                </li>
              </ul>
            </div>

            <button
              type="button"
              id="btnModalClose"
              v-on:click="closeModal()"
              class="close position-relative"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>

            <!------image hld start---->
            <div class="attendee-box-hld text-center pt-4 position-relative">
              <v-badge
                v-if="currentAttendee && loggedInUseID != currentAttendee.id"
                color="white"
                bottom
                class="attendee-presence-side-popup"
              >
                <template #badge>
                  <div v-if="!isBookmarked">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          size="32"
                          color="black"
                          @click="addBookMark()"
                          style="cursor: pointer"
                          v-on="on"
                          >bookmark_border</v-icon
                        >
                      </template>
                      <span>Bookmark</span>
                    </v-tooltip>
                  </div>

                  <div v-else>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          size="32"
                          color="success"
                          @click="addBookMark()"
                          style="cursor: pointer"
                          >bookmark</v-icon
                        ></template
                      >
                      <span>Bookmarked</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-badge>

              <div
                class="attendee-side-popup-presence-indicator position-relative d-inline-block"
              >
                <span
                  v-if="currentAttendee"
                  :class="
                    currentAttendee.isOnline
                      ? 'attendee-status-bubble  attendee-online-status'
                      : 'attendee-status-bubble  attendee-off-online-status'
                  "
                ></span>
                <div
                  id="dvImgeHldText"
                  class="attendee-img-hld mx-auto"
                  v-show="!imageExists"
                >
                  <img id="imgModalSpeakers" class="imguserthumb" />
                </div>
                <div
                  v-show="imageExists"
                  id="dvImgeHld"
                  class="attendee-img-hld mx-auto"
                  data-toggle="modal"
                  data-target="#modalZoomImage"
                >
                  <img
                    v-if="currentAttendee && currentAttendee.Image"
                    id="imgModalSpeakers"
                    :src="currentAttendee.Image"
                    class="imguserthumb"
                  />
                </div>
                <!-- <div id="dvImgeHldText" class="attendee-img-hld mx-auto"></div> -->
              </div>

              <div class="attendee-des-hld">
                <h3 id="modalReceiverId" hidden></h3>
                <h3 id="modalName"></h3>
                <p id="modalCompany"></p>
                <p id="modalTtile"></p>
                <p v-show="ShowEmailandPhone" id="modalEmail"></p>
              </div>
              <!--------social----->
              <div class="social-icon d-flex justify-content-center">
                <a
                  id="anchFacebook"
                  data-tag="Facebook"
                  v-on:click="onClickHandler"
                  href="#"
                  target="_blank"
                >
                  <span id="spnFacebook">
                    <i
                      class="fa fa-facebook"
                      id="iFacebook"
                      aria-hidden="true"
                    ></i>
                  </span>
                </a>
                <a
                  id="anchTwitter"
                  data-tag="Twitter"
                  v-on:click="onClickHandler"
                  href="#"
                  target="_blank"
                >
                  <span id="spnTwitter">
                    <i
                      class="fa fa-twitter"
                      id="iTwitter"
                      aria-hidden="true"
                    ></i>
                  </span>
                </a>
                <a
                  id="anchLinkedIn"
                  data-tag="LinkedIn"
                  v-on:click="onClickHandler"
                  href="#"
                  target="_blank"
                >
                  <span id="spnLinkedIn">
                    <i
                      class="fa fa-linkedin"
                      id="iLinkedIn"
                      aria-hidden="true"
                    ></i>
                  </span>
                </a>
              </div>
              <!--------social----->
              <!--button area start--->
              <!-- data-target="#calendarModal"
              data-toggle="modal" -->
              <div class="button-area-hld text-center btn-theme">
                <button
                  id="btnOpenRequestMeeting"
                  @click="OpenRequestMeeting"
                  v-on:click="onClickHandler"
                  v-show="ShowMeetingButton"
                  class="btn request-meeting mt-1 border-tranprent"
                >
                  {{ $t("speaker.requestmeeting") }}
                </button>

                <a
                  v-if="currentAttendee && loggedInUseID != currentAttendee.id"
                  id="btnShowSendMessageButton"
                  target="_blank"
                  v-show="ShowSendMessageButton"
                  v-on:click="onClickHandler"
                  data-tag="ShowSendMessageButton"
                  class="btn send-message ml-md-2 ml-0 mt-1 request-meeting"
                  href=""
                >
                  {{ $t("speaker.sendmessage") }}
                </a>
              </div>
              <!---button area end-->
              <!-----tab-area------->
              <div class="speakers-detailstab session-list-wrapper">
                <ul
                  role="tablist"
                  id="ulTabList"
                  class="nav nav-tabs text-uppercase"
                >
                  <li class="nav-item">
                    <a
                      data-toggle="tab"
                      id="aBiography"
                      href="#Biograply"
                      v-on:click="onClickHandler"
                      class="nav-link active"
                      >{{ $t("speaker.biography") }}</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      data-toggle="tab"
                      id="aSession"
                      href="#Session"
                      v-on:click="onClickHandler"
                      class="nav-link"
                      >{{ $t("speaker.session") }}</a
                    >
                  </li>
                  <li class="nav-item" id="liResourceTab">
                    <a
                      data-toggle="tab"
                      id="aResource"
                      href="#Resource"
                      v-on:click="onClickHandler"
                      class="nav-link"
                      >{{ $t("speaker.resources") }}</a
                    >
                  </li>
                </ul>
              </div>
              <!-----tab conten  startt----->
              <div class="tab-content mt-3">
                <!--Biograply tab content start--->
                <div id="Biograply" class="tab-pane active">
                  <div
                    id="modalProfile"
                    class="text-left speaker-profile-space"
                  ></div>
                </div>
                <!------session tab start-->
                <!-- 
                  v-on:click="goToSession" -->
                <div
                  id="Session"
                  class="tab-pane session-autoflow-list text-left"
                >
                  <!-- <div class="session-tab-innerBox p-3 mb-2">
                    <h5 class>Testing Singapore Event</h5>
                    <p class="event-date">Jul 16 11:30 to Aug 31 15:30 Asia/Calcutta</p>
                  </div>
                  <div class="session-tab-innerBox p-3 mb-2">
                    <h5 class>Testing Singapore Event</h5>
                    <p class="event-date">Jul 16 11:30 to Aug 31 15:30 Asia/Calcutta</p>
                  </div>-->
                  <h6 class="session-time-zone mt-md-1" style="color: #8b8b8b">
                    {{ localTimeZone }}
                  </h6>
                  <div
                    v-for="(item, index) in speakersSessionList"
                    :key="'session_' + index + '_' + item.SessionId"
                    class="session-tab-innerBox p-3 mb-2"
                    @click="DisplaySessionDetails(item)"
                  >
                    <h5 class>
                      {{ item.Name }}
                    </h5>
                    <p class="event-date">
                      {{ item.StartTimeLabel }} -
                      {{
                        item.StartTimeLabel.substr(0, 7) ==
                        item.EndTimeLabel.substr(0, 7)
                          ? item.EndTimeLabel.substr(
                              7,
                              item.EndTimeLabel.length
                            )
                          : item.EndTimeLabel
                      }}
                      <!-- 
                      {{ item.StartTimeLabel }}
                      to
                      {{ item.EndTimeLabel }} -->
                    </p>
                  </div>
                </div>
                <!------>
                <!------Resource tab start-->

                <div id="Resource" class="tab-pane text-left"></div>
              </div>
              <!----tab content wrapper end--->
            </div>
            <!------image hld end---->
          </div>
        </div>
        <!-- modal-content -->
      </div>
      <!-- modal-dialog -->
    </div>
    <!-- modal -->
    <div
      class="modal fade profile-zoom-effect"
      id="modalZoomImage"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            data-supported-dps="24x24"
            fill="#ffffff"
            width="24"
            height="24"
            focusable="false"
          >
            <path
              d="M20 5.32L13.32 12 20 18.68 18.66 20 12 13.33 5.34 20 4 18.68 10.68 12 4 5.32 5.32 4 12 10.69 18.68 4z"
            />
          </svg>
        </button>
      </div>
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-zoom modal-lg"
        role="document"
      >
        <div class="modal-content align-items-center justify-content-center">
          <div class="modal-body">
            <div class="big-img-wrapper">
              <img
                id="imgModalSpeakerEnlarge"
                src="../assets/Images/new-attendee-img.jpg"
                class="imguserthumb"
              />
              <!-- PH -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <RequestMeeting
      :key="requestMeetingKey"
      :attendee="currentAttendee"
    ></RequestMeeting>
    <!----------right attendee detail-------->
    <v-dialog
      v-model="sessionDetailsPopup"
      width="1000px"
      content-class="reg-options-whole position-relative"
      style="z-index: 1050"
    >
      <v-card>
        <v-btn
          class="goto-option-close"
          icon
          @click="sessionDetailsPopup = false"
          ><v-icon color="#333" size="25px">mdi-close</v-icon></v-btn
        >
        <v-card-text class="p-0">
          <SessionDetails
            :key="sessionDetailsKey"
            :sn="currentSession"
            :hide_speaker_enabled="false"
            :isPublicPage="false"
            :IsMyAgenda="false"
            :AllowAddRemoveMyAgenda="false"
            :hideJoinButton="true"
          ></SessionDetails>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- @onStartSession="onStartSession"
            @addToMyAgenda="addToMyAgenda"
            @removeFromMyAgenda="removeFromMyAgenda"
            @openSpeakerDetails="openSpeakerDetails" -->
  </div>
</template>

<style>
.attendee-box-hld .v-badge__badge {
  display: none !important;
}
.attendee-box-hld:hover .v-badge__badge {
  display: block !important;
}
.attendee-box-badge {
  position: absolute;
  top: 4px;
  right: 45px;
}
.attendee-status-bubble {
  position: absolute;
  display: inline-block;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  background: #f00;
  border: 2px solid #fff;
  bottom: 6px;
  right: 20px;
}

.attendee-online-status {
  background: #1d940d !important;
}
.attendee-off-online-status {
  background: #d1d1d1 !important;
}

.attendee-presence-status {
  display: inline-block;
  border-radius: 50%;
}
.attendee-presence-side-popup {
  position: absolute;
  left: 20px;
  top: 0;
}
.session-time-zone {
  text-align: left;
  color: #8b8b8b;
}
.session-time-zone:before {
  content: "\f0ac";
  font: normal normal normal 16px/1 FontAwesome;
  height: 15px;
  width: 15px;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  color: #919297;
  padding-right: 5px;
}
</style>

<script>
import Vue from "vue";
import db from "../components/firebaseInit";
import analytics from "@/components/Analytics";
import jQuery from "jquery";
let $ = jQuery;
import router from "../router";
let lastVisible = null;
let hasMore = true;
var self;
import APIs from "@/components/APIInit";
import axios from "axios";
import RequestMeeting from "@/components/RequestMeeting.vue";
import SessionDetails from "@/components/SessionDetails.vue";
import common from "@/common";
import { bus } from "@/main";

var monthNamesShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export default {
  components: {
    RequestMeeting,
    SessionDetails,
  },
  props: {
    isAdminComponent: {
      type: Boolean,
      default: false,
    },
    isRegistrationComponent: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    async speakerEvent(val) {
      if (val) {
        this.$store.commit("addEventCollection", val.iceId);
        this.$store.commit("addEventID", val.EventId);
        self.IsSearchMode = true;
        self.getDBSearchedSpekers();
        // await this.getSpeakerDetails();
      }
    },
    activeUsersInsideEvent() {
      self.attendeeData.map((attendee) => {
        attendee.isOnline = self.getAttendeeLoggedInStatus(attendee.id);
      });
    },
  },
  data() {
    return {
      imageExists: null,
      activeUsersInsideEvent: [],
      isBookmarked: false,
      currentAttendee: null,
      requestMeetingKey: 0,
      speakerEvent: false,
      EnableSpeakerDBsearch: true,
      headerText: this.$t("speaker.speakers"),
      searchtext: "",
      IsSearchMode: false,
      ShowMeetingButton: false,
      ShowSendMessageButton: false,
      ShowFilter: false,
      ShowSearch: false,
      ShowEmailandPhone: false,
      pageSize: 1000,
      pageIndex: 0,
      totalRecords: 1,
      lastVisible: null,
      attendeeData: [],
      spkFilterData: [],
      speakersSessionList: [],
      sessionDetailsPopup: false,
      sessionDetailsKey: 0,
      currentSession: null,
      spkrFilter: "",
      clientID: this.$store.getters.getClient[0].id,
      IsShowNoDataFound: false,
      textColor: "black",
      eventId: "",
      requestorId: null,
      APIs: APIs,
      loggedInUseID: "",
      localTimeZone: "",
    };
  },
  created() {
    self = this;
    //window.addEventListener("scroll", this.onScrollHandler);
    var obj = JSON.parse(window.localStorage.getItem("my-app"));

    if (obj && obj.user && obj.user.length > 0) {
      self.loggedInUseID = obj.user[0].id;
    }
    hasMore = true;
    lastVisible = null;
    bus.$on("activeUsersList", (data) => {
      self.activeUsersInsideEvent = data;
    });
    self.localTimeZone = common.getTimeZoneName();
  },
  beforeDestroy() {
    // window.removeEventListener("scroll", this.onScrollHandler);
    lastVisible = null;
    self.attendeeData = [];
    self.searchtext = "";
  },
  async mounted() {
    await this.getSpeakerDetails();
  },
  methods: {
    openAddNewSpeakerPopup() {
      bus.$emit("openAddNewSpeakerPopup");
    },
    editCurrentSpeaker() {
      console.log("speaker======", this.currentAttendee);

      var attendee = {
        Name: this.currentAttendee.Name,
        FirstName: this.currentAttendee.FirstName,
        LastName: this.currentAttendee.LastName,
        Email: this.currentAttendee.Email,
        //Password: randomNumber,
        Tags: this.currentAttendee.Tags,
        Phone: this.currentAttendee.Phone,
        Country: "",
        FormType: "FREE",
        RegistrationType: {
          ColorCode: "",
          RegistrationType: "Attendee",
          RegistrationTypeId: "",
        },
        Company: this.currentAttendee.Company,
        Designation: this.currentAttendee.Designation,
        Profile: this.currentAttendee.Profile,
        ProfilePictureURL: this.currentAttendee.ProfilePictureURL
          ? this.currentAttendee.ProfilePictureURL
          : this.currentAttendee.Image
          ? this.currentAttendee.Image
          : "",
        Website: this.currentAttendee.Website,
        SocialLinks: this.currentAttendee.SocialLinks,
        AttendeeId: this.currentAttendee.id,
        IsPublished: this.currentAttendee.IsPublished,
      };
      self.closeModal();
      // $("body").removeClass("modal-open");
      // $(".modal-backdrop").remove();

      self.$emit("OpenAddSpeakerPopup", attendee);
    },
    closeModal: function () {
      $("#myModal2").removeClass("show");
      $("#myModal2").hide();
      $("#myModal2").modal("hide");

      // $("#dvBackDrop").hide();
      // $("#dvBackDrop").removeClass("show");
      // router.push("/attendee");
    },
    OpenAddSpeakerPopup() {
      self.$emit("OpenAddSpeakerPopup");
    },
    async addBookMark() {
      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          eventName: this.$store.state.eventname,
          enetityUserId: this.$store.state.userId,
          attendeeId: this.$store.state.userId,
          entityType: 2,
          entityName: this.currentAttendee.Name,
          entityImage: this.currentAttendee.Image
            ? this.currentAttendee.Image
            : "",
          entityId: this.currentAttendee.id,
          entityLink: this.$route.path,
        },
      };
      if (this.isBookmarked) {
        this.isBookmarked = false;
        axios({
          method: "post",
          url: self.APIs.BookmarkAPIConfig.Delete,
          data: rqstData,
        })
          .then(() => {
            this.isBookmarked = false;
            debugger;
            var attendees = self.attendeeData.filter(function (objAttendee) {
              return objAttendee.id == self.currentAttendee.id;
            });
            if (attendees.length > 0) {
              attendees[0].isBookmarked = false;
              self.attendeeData = self.attendeeData.filter(function () {
                return true;
              });
            }
          })
          .catch(() => {
            this.isBookmarked = true;
          });
      } else {
        this.isBookmarked = true;
        axios({
          method: "post",
          url: self.APIs.BookmarkAPIConfig.Create,
          data: rqstData,
        })
          .then(() => {
            this.isBookmarked = true;
            var attendees = self.attendeeData.filter(function (objAttendee) {
              return objAttendee.id == self.currentAttendee.id;
            });
            if (attendees.length > 0) {
              attendees[0].isBookmarked = true;
              self.attendeeData = self.attendeeData.filter(function () {
                return true;
              });
            }
          })
          .catch(() => {
            this.isBookmarked = false;
          });
      }
    },
    getAttendeeLoggedInStatus(attendeeId) {
      if (self.activeUsersInsideEvent.includes(attendeeId)) {
        return true;
      } else {
        return false;
      }
    },
    addAttendeeBookMark(attendeeId, Name, Image, isBookmarked, e) {
      e.stopPropagation();
      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          eventName: this.$store.state.eventname,
          enetityUserId: this.$store.state.userId,
          attendeeId: this.$store.state.userId,
          entityType: 2,
          entityName: Name,
          entityImage: Image ? Image : "",
          entityId: attendeeId,
          entityLink: this.$route.path,
        },
      };
      if (isBookmarked) {
        axios({
          method: "post",
          url: self.APIs.BookmarkAPIConfig.Delete,
          data: rqstData,
        })
          .then(() => {
            var attendees = self.attendeeData.filter(function (objAttendee) {
              return objAttendee.id == attendeeId;
            });
            if (attendees.length > 0) {
              attendees[0].isBookmarked = false;
              self.attendeeData = self.attendeeData.filter(function () {
                return true;
              });
            }
            self.showSnackbar("Bookmark removed successfully.", "info", "top");
          })
          .catch(() => {});
      } else {
        axios({
          method: "post",
          url: self.APIs.BookmarkAPIConfig.Create,
          data: rqstData,
        })
          .then(() => {
            var attendees = self.attendeeData.filter(function (objAttendee) {
              return objAttendee.id == attendeeId;
            });
            if (attendees.length > 0) {
              attendees[0].isBookmarked = true;
              self.attendeeData = self.attendeeData.filter(function () {
                return true;
              });
            }
            self.showSnackbar("Bookmark added successfully.", "info", "top");
          })
          .catch(() => {});
      }
    },
    getBookmarkStatus(attendeeId, name, image, isBookmarked, isLoading) {
      if (isBookmarked == undefined && !isLoading) {
        console.log("isBookmarked: " + isBookmarked);
        console.log("isLoading: " + isLoading);
        var attendees = self.attendeeData.filter(function (objAttendee) {
          return objAttendee.id == attendeeId;
        });
        if (attendees.length > 0) {
          if (attendees[0].isBookmarked == undefined) {
            attendees[0].isBookmarked = false;
          }
          attendees[0].isLoading = true;
          self.attendeeData = self.attendeeData.filter(function () {
            return true;
          });
          var rqstData = {
            key: {
              instanceId: "OA_UAT",
              clientId: this.$store.state.client[0].id,
              eventId: this.$store.state.eventid,
            },
            data: {
              eventName: this.$store.state.eventname,
              enetityUserId: this.$store.state.userId,
              attendeeId: this.$store.state.userId,
              entityType: 2,
              entityName: name,
              entityImage: image,
              entityId: attendeeId,
            },
          };
          try {
            axios({
              method: "post",
              url: self.APIs.BookmarkAPIConfig.Get,
              data: rqstData,
            }).then(function (response) {
              if (
                response &&
                response.data &&
                response.data.isPublished != undefined
              ) {
                attendees[0].isBookmarked = response.data.isPublished;
              }
              self.attendeeData = self.attendeeData.filter(function () {
                return true;
              });
              attendees[0].isLoading = false;
            });
          } catch (e) {
            attendees[0].isBookmarked = false;
            attendees[0].isLoading = false;
            self.attendeeData = self.attendeeData.filter(function () {
              return true;
            });
            console.log(e);
          }
        }
      }
    },
    async getSpeakerDetails() {
      window.addEventListener("scroll", this.scroll);
      document.body.addEventListener("scroll", this.scroll);
      var obj = JSON.parse(window.localStorage.getItem("my-app"));

      if (obj) {
        self.eventId = obj.eventid;
      }
      if (obj.EventFont != undefined) {
        if (obj.EventFont.length > 0) {
          var urlpath = "";
          if (obj.EventFont[0].FontPath != "") {
            if (obj.EventFont[0].FontFamily != "") {
              urlpath = obj.EventFont[0].FontPath;

              var newStyle = document.createElement("style");
              newStyle.appendChild(
                document.createTextNode(
                  "\
@font-face {\
    font-family: " +
                    obj.EventFont[0].FontFamily +
                    ";\
    src:" +
                    urlpath +
                    " ;\
}\
"
                )
              );

              document.head.appendChild(newStyle);

              $(
                "<style>* { font-family: '" +
                  obj.EventFont[0].FontFamily +
                  "' !important }</style>"
              ).appendTo("head");
            }
          } else {
            $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
              "head"
            );
          }
        }
      }

      db.collection(obj.eventcollectionname)
        .doc("Menu")
        .get()
        .then((doc) => {
          var data = doc.data();
          $.each(data.AllMenu, function (key, value) {
            if (value.GroupID != 99) {
              if (value.Name == "Speakers") {
                if (self.$store.state.locale == "English") {
                  self.headerText = value.DisplayLabel;
                } else if (self.$store.state.locale == "German") {
                  self.headerText = value.DisplayLabel_de;
                } else if (self.$store.state.locale == "French") {
                  self.headerText = value.DisplayLabel_fr;
                } else if (self.$store.state.locale == "Chinese") {
                  self.headerText = value.DisplayLabel_zh;
                } else if (self.$store.state.locale == "Spanish") {
                  self.headerText = value.DisplayLabel_es;
                } else {
                  self.headerText = value.DisplayLabel;
                }
              }
            }
          });
          $.each(data.LeftMenu, function (key, value) {
            if (value.GroupID != 99) {
              if (value.Name == "Speakers") {
                if (self.$store.state.locale == "English") {
                  self.headerText = value.DisplayLabel;
                } else if (self.$store.state.locale == "German") {
                  self.headerText = value.DisplayLabel_de;
                } else if (self.$store.state.locale == "French") {
                  self.headerText = value.DisplayLabel_fr;
                } else if (self.$store.state.locale == "Chinese") {
                  self.headerText = value.DisplayLabel_zh;
                } else if (self.$store.state.locale == "Spanish") {
                  self.headerText = value.DisplayLabel_es;
                } else {
                  self.headerText = value.DisplayLabel;
                }
              }
            }
          });
          document.title = self.headerText + " - " + obj.eventname;
        });

      document.title = self.headerText + " - " + obj.eventname;
      //-------------------FAVICONJOB------------------------------------------------------------
      if (obj.branding[0].favicon != undefined) {
        if (obj.branding[0].favicon != "") {
          var link =
            document.querySelector("link[rel*='icon']") ||
            document.createElement("link");
          link.type = "image/x-icon";
          link.rel = "shortcut icon";
          link.href = obj.branding[0].favicon;
          document.getElementsByTagName("head")[0].appendChild(link);
        }
      }
      //----------------------------------------------------------------------------------

      var brandingData;
      try {
        brandingData = await self.getBrandingJSONDetails(
          obj.eventcollectionname + "/Branding/Branding.json"
        );
        if (brandingData.data != undefined) {
          if (brandingData.data.EventInfo != undefined) {
            if (brandingData.data.EventInfo.BodyTextColor != undefined) {
              self.textColor = brandingData.data.EventInfo.BodyTextColor;
            } else {
              self.textColor = "black";
            }
          } else {
            self.textColor = "black";
          }
          console.log("BodyTextColor :- " + self.textColor);
          if (!self.isAdminComponent) {
            $("#headerText").css("color", self.textColor);
          }
        }
      } catch (e) {
        console.log("Error in Branding Json Fetch--", e);
      }

      //------------------------------------------------------------------------------
      $("#btnAddUserView").click();
      // $("#topmenu").show();
      // $("#leftmenu").show();
      //self.attendeeData = [];
      this.displayAttendees();
      //this.scroll();
      self.searchtext = "";
      self.spkrFilter = "";

      $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);
      if (!self.isAdminComponent) {
        $("#sectionId").css(
          "background-image",
          "url(" + obj.EventBranding[0].eventBGImage + ")"
        );
      }
      //--------get  setting---------------------------------------------------------------------------------

      self.ShowMeetingButton = false;
      self.ShowFilter = false;
      self.ShowSendMessageButton = false;
      self.ShowSearch = false;
      var refSpeakerSettings = db
        .collection(obj.eventcollectionname)
        .doc("Settings")
        .collection("Speaker")
        .doc("SpeakerSettings");
      refSpeakerSettings
        .get()
        .then(function (doc) {
          if (doc.exists) {
            self.ShowMeetingButton =
              doc.data().ShowMeetingButton == undefined
                ? false
                : doc.data().ShowMeetingButton;
            self.ShowSendMessageButton =
              doc.data().ShowSendMessageButton == undefined
                ? false
                : doc.data().ShowSendMessageButton;
            self.ShowFilter =
              doc.data().ShowFilter == undefined
                ? false
                : doc.data().ShowFilter;
            self.ShowSearch =
              doc.data().ShowSearch == undefined
                ? false
                : doc.data().ShowSearch;
            self.ShowEmailandPhone =
              doc.data().ShowEmailandPhone == undefined
                ? false
                : doc.data().ShowEmailandPhone;
          }
        })
        .catch((e) => {
          console.log(e);
        });
      this.getFilterList();
      self.setFirebaseAppsettings();
    },
    setFirebaseAppsettings: function () {
      var docRefGeneralSettings = db
        .collection("OA_UAT")
        .doc("GeneralSettings");
      docRefGeneralSettings
        .get()
        .then(function (doc) {
          if (doc.exists) {
            self.EnableSpeakerDBsearch =
              doc.data().EnableSpeakerDBsearch != undefined
                ? doc.data().EnableSpeakerDBsearch
                : true;
          }
          console.log("EnableSpeakerDBsearch - " + self.EnableSpeakerDBsearch);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getDBSearchedSpekers: function () {
      self.IsSearchMode = true;
      console.log(self.searchtext);
      // if (!hasMore) {
      //   return;
      // }
      //this.pageIndex++;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));

      try {
        var listRef = db
          .collection(obj.eventcollectionname)
          .doc("SpeakerList")
          .collection("Speakers");
        if (!self.isAdminComponent) {
          listRef = listRef.where("IsPublished", "==", true);
        }

        // if (lastVisible == null) {
        //   listRef = listRef.limit(this.pageSize);
        // } else {
        //   listRef = listRef.startAfter(lastVisible).limit(this.pageSize);
        // }
        var speakerlistLocal = [];
        listRef
          .get()
          .then((querySnapshot) => {
            // hasMore = querySnapshot.docs.length > 0;
            // if (hasMore) {
            // lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
            //   self.attendeeData = [];
            querySnapshot.forEach((doc) => {
              var filteredRows = speakerlistLocal.filter(function (value) {
                return value.id == doc.id;
              });

              if (filteredRows.length == 0) {
                var tbObj = new Object();
                tbObj.id = doc.id;
                //tbObj.AttendeeId = doc.id;
                tbObj.Name =
                  (doc.data().FirstName == undefined
                    ? ""
                    : doc.data().FirstName.trim()) +
                  " " +
                  (doc.data().LastName == undefined
                    ? ""
                    : doc.data().LastName.trim());
                tbObj.Email =
                  doc.data().Email != undefined ? doc.data().Email : "";
                tbObj.HideInList = doc.data().HideInList
                  ? doc.data().HideInList
                  : false;
                tbObj.IsPublished =
                  doc.data().IsPublished != undefined
                    ? doc.data().IsPublished
                    : false;
                tbObj.Image =
                  doc.data().ProfilePictureURL != undefined
                    ? self.getCDNUrl(doc.data().ProfilePictureURL)
                    : "";
                tbObj.Company =
                  doc.data().Company != undefined ? doc.data().Company : "";
                tbObj.Designation =
                  doc.data().Designation != undefined
                    ? doc.data().Designation
                    : "";
                tbObj.Profile =
                  doc.data().Profile == undefined ? "" : doc.data().Profile;
                tbObj.Resources = doc.data().Resources
                  ? doc.data().Resources
                  : [];
                tbObj.SocialLinks = doc.data().SocialLinks
                  ? doc.data().SocialLinks
                  : [];
                tbObj.Initials = common.getInitials(
                  (doc.data().FirstName == undefined
                    ? ""
                    : doc.data().FirstName.trim()) +
                    " " +
                    (doc.data().LastName == undefined
                      ? ""
                      : doc.data().LastName.trim())
                );

                if (
                  tbObj.Name.toLowerCase().includes(
                    self.searchtext.toLowerCase()
                  ) ||
                  tbObj.Email.toLowerCase().includes(
                    self.searchtext.toLowerCase()
                  ) ||
                  tbObj.Company.toLowerCase().includes(
                    self.searchtext.toLowerCase()
                  ) ||
                  tbObj.Designation.toLowerCase().includes(
                    self.searchtext.toLowerCase()
                  ) ||
                  tbObj.Profile.toLowerCase().includes(
                    self.searchtext.toLowerCase()
                  )
                ) {
                  speakerlistLocal.push(tbObj);
                }
              }
              if (speakerlistLocal.length > 0) {
                self.IsShowNoDataFound = false;
              } else {
                self.IsShowNoDataFound = true;
              }
            });
            //}hasmore
            self.attendeeData = speakerlistLocal;
            self.attendeeData.sort(function (a, b) {
              if (a.Name < b.Name) {
                return -1;
              }
              if (a.Name > b.Name) {
                return 1;
              }
              return 0;
            });
          })
          .catch((error) => {
            console.log(error);
            // console.log("Error getting documents: ", error);
          });
      } catch (error) {
        console.log(error);
      }
    },
    displayAttendees() {
      self.IsSearchMode = true;
      if (self.searchtext.trim() != "") {
        if (self.EnableSpeakerDBsearch) {
          self.getDBSearchedSpekers();
        } else {
          var hostUrl = location.host.toLowerCase();
          var searchUrl = "";
          // searchUrl =
          //   "https://us-central1-uate2monair.cloudfunctions.net/app/api/searchspeakers/" +
          //   self.searchtext;
          //----------------------------------------------------------------------------------------
          if (hostUrl.includes("localhost")) {
            searchUrl =
              "https://us-central1-uate2monair.cloudfunctions.net/app/api/searchspeakers/" +
              self.searchtext;
          } else {
            if (hostUrl.includes("uat")) {
              searchUrl =
                "https://us-central1-uate2monair.cloudfunctions.net/app/api/searchspeakers/" +
                self.searchtext;
            } else {
              searchUrl =
                "https://us-central1-e2monair.cloudfunctions.net/app/api/searchspeakers/" +
                self.searchtext;
            }
          }
          //----------------------------------------------------------------------------------------------------
          self.attendeeData = [];
          console.log(self.clientID);
          console.log(self.eventId);
          //+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

          let headers = {
            "Content-Type": "application/json",
            apikey: "ws2000rb28082019",
            InstancePrefix: "OA",
            clientID: self.clientID,
            Env: "UAT",
            eventID: self.eventId,
          };
          bus.$emit("toggleLoader", true);
          axios
            .get(searchUrl, false, {
              headers: headers,
            })
            .then((response) => {
              let data = response.data;

              self.attendeeData = [];
              bus.$emit("toggleLoader", false);
              for (var i = 0; i < data.length; i++) {
                var filteredRows = self.attendeeData.filter(function (value) {
                  return (
                    value.id ==
                    (data[i].AttendeeId != undefined ? data[i].AttendeeId : "")
                  );
                });

                if (filteredRows.length == 0) {
                  var objAttendee = {
                    id:
                      data[i].AttendeeId != undefined
                        ? data[i].AttendeeId
                        : "0",
                    //AttendeeId:
                    //  data[i].AttendeeId != undefined
                    //    ? data[i].AttendeeId
                    //    : "0",
                    attendeeId:
                      data[i].AttendeeId != undefined
                        ? data[i].AttendeeId
                        : "0",
                    Name:
                      (data[i].FirstName != undefined
                        ? data[i].FirstName.trim()
                        : "") +
                      " " +
                      (data[i].LastName != undefined
                        ? data[i].LastName.trim()
                        : ""),
                    FirstName:
                      data[i].FirstName != undefined
                        ? data[i].FirstName.trim()
                        : "",
                    LastName:
                      data[i].LastName != undefined
                        ? data[i].LastName.trim()
                        : "",
                    Email: data[i].Email != undefined ? data[i].Email : "",
                    HideInList: data[i].HideInList ? data[i].HideInList : false,
                    IsPublished:
                      data[i].IsPublished != undefined
                        ? data[i].IsPublished
                        : false,
                    Image:
                      data[i].ProfilePictureURL != undefined
                        ? self.getCDNUrl(data[i].ProfilePictureURL)
                        : "",
                    Designation:
                      data[i].Designation != undefined
                        ? data[i].Designation
                        : "",
                    Company:
                      data[i].Company != undefined ? data[i].Company : "",
                    Profile:
                      data[i].Profile != undefined ? data[i].Profile : "",
                    Phone: data[i].Phone != undefined ? data[i].Phone : "",
                    Tags: data[i].Tags ? data[i].Tags : "",
                    Website:
                      data[i].Website != undefined ? data[i].Website : "",
                    SocialLinks:
                      data[i].SocialLinks != undefined
                        ? data[i].SocialLinks
                        : [],
                    Initials: common.getInitials(
                      (data[i].FirstName != undefined
                        ? data[i].FirstName.trim()
                        : "") +
                        " " +
                        (data[i].LastName != undefined
                          ? data[i].LastName.trim()
                          : "")
                    ),
                  };

                  objAttendee.FirstName = objAttendee.FirstName.trim();
                  objAttendee.LastName = objAttendee.LastName.trim();
                  objAttendee.Name =
                    objAttendee.FirstName + " " + objAttendee.LastName;

                  var sLinks =
                    objAttendee.SocialLinks != undefined
                      ? objAttendee.SocialLinks
                      : [];
                  sLinks.forEach((sLink) => {
                    if (sLink["Facebook"] != undefined) {
                      objAttendee.Facebook =
                        sLink["Facebook"] == undefined ? "" : sLink["Facebook"];
                    }
                    if (sLink["Twitter"] != undefined) {
                      objAttendee.Twitter =
                        sLink["Twitter"] == undefined ? "" : sLink["Twitter"];
                    }
                    if (sLink["LinkedIn"] != undefined) {
                      objAttendee.LinkedIn =
                        sLink["LinkedIn"] == undefined ? "" : sLink["LinkedIn"];
                    }
                    if (sLink["GooglePlus"] != undefined) {
                      objAttendee.GooglePlus =
                        sLink["GooglePlus"] == undefined
                          ? ""
                          : sLink["GooglePlus"];
                    }
                  });
                  objAttendee.isOnline = self.getAttendeeLoggedInStatus(
                    data[i].AttendeeId
                  );

                  self.attendeeData.push(objAttendee);
                }
              }
              // console.log(self.attendeeData);
              if (self.attendeeData.length > 0) {
                self.IsShowNoDataFound = false;
              } else {
                self.IsShowNoDataFound = true;
              }
            })
            .catch((error) => {
              console.log(error);
              bus.$emit("toggleLoader", false);
              self.IsShowNoDataFound = true;
              return false;
            });
          //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
          lastVisible = null;
          hasMore = true;
        }
      } else {
        self.IsShowNoDataFound = false;
        self.IsSearchMode = false;
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        //console.log("EventColName : " + obj.eventcollectionname);

        if (
          self.spkrFilter != undefined &&
          self.spkrFilter != "" &&
          self.spkrFilter.length > 0 &&
          self.spkrFilter != "All"
        ) {
          // this.pageIndex++;
          hasMore = true;
          let listRef = db
            .collection(obj.eventcollectionname)
            .doc("SpeakerList")
            .collection("Speakers");

          listRef = db
            .collection(obj.eventcollectionname)
            .doc("SpeakerList")
            .collection("Speakers");

          if (!self.isAdminComponent) {
            listRef = listRef.where("IsPublished", "==", true);
          }
          listRef = listRef
            .where("Group", "==", self.spkrFilter)
            .orderBy("Name", "asc");

          self.attendeeData = [];
          listRef
            .get()
            .then((querySnapshot) => {
              bus.$emit("toggleLoader", false);
              querySnapshot.forEach((doc) => {
                var filteredRows = self.attendeeData.filter(function (value) {
                  return value.id == doc.id;
                });
                if (filteredRows.length == 0) {
                  self.attendeeData.push({
                    id: doc.id,
                    //AttendeeId: doc.id,
                    Name:
                      (doc.data().FirstName == undefined
                        ? ""
                        : doc.data().FirstName.trim()) +
                      " " +
                      (doc.data().LastName == undefined
                        ? ""
                        : doc.data().LastName.trim()),
                    FirstName:
                      doc.data().FirstName != undefined
                        ? doc.data().FirstName
                        : "",
                    LastName:
                      doc.data().LastName != undefined
                        ? doc.data().LastName
                        : "",
                    Email: doc.data().Email,
                    Tags: doc.data().Tags ? doc.data().Tags : "",
                    Phone:
                      doc.data().Phone != undefined ? doc.data().Phone : "",
                    Website:
                      doc.data().Website != undefined ? doc.data().Website : "",
                    HideInList: doc.data().HideInList
                      ? doc.data().HideInList
                      : false,
                    IsPublished:
                      doc.data().IsPublished != undefined
                        ? doc.data().IsPublished
                        : false,
                    Image: self.getCDNUrl(doc.data().ProfilePictureURL),
                    Company: doc.data().Company,
                    Designation: doc.data().Designation,
                    Profile:
                      doc.data().Profile == undefined ? "" : doc.data().Profile,
                    Resources: doc.data().Resources ? doc.data().Resources : [],
                    SocialLinks: doc.data().SocialLinks
                      ? doc.data().SocialLinks
                      : [],
                    Initials: common.getInitials(
                      (doc.data().FirstName == undefined
                        ? ""
                        : doc.data().FirstName.trim()) +
                        " " +
                        (doc.data().LastName == undefined
                          ? ""
                          : doc.data().LastName.trim())
                    ),
                    //ShowSearch: self.ShowSearch
                  });
                }
              });
              // self.attendeeData.sort(function (a, b) {
              //   if (a.Name < b.Name) {
              //     return -1;
              //   }
              //   if (a.Name > b.Name) {
              //     return 1;
              //   }
              //   return 0;
              // });
            })
            .catch((error) => {
              bus.$emit("toggleLoader", false);
              console.log(error);
              // console.log("Error getting documents: ", error);
            });
          lastVisible = null;
        } else {
          if (!hasMore) {
            return;
          }
          this.pageIndex++;

          let listRef = db
            .collection(obj.eventcollectionname)
            .doc("SpeakerList")
            .collection("Speakers");

          if (!self.isAdminComponent) {
            listRef = listRef.where("IsPublished", "==", true);
          }
          listRef = listRef.orderBy("Name", "asc");

          if (lastVisible == null) {
            listRef = listRef.limit(this.pageSize);
          } else {
            listRef = listRef.startAfter(lastVisible).limit(this.pageSize);
          }

          listRef
            .get()
            .then((querySnapshot) => {
              bus.$emit("toggleLoader", false);
              hasMore = querySnapshot.docs.length > 0;
              if (hasMore) {
                lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
                querySnapshot.forEach((doc) => {
                  var filteredRows = self.attendeeData.filter(function (value) {
                    return value.id == doc.id;
                  });
                  if (filteredRows.length == 0) {
                    debugger;
                    self.attendeeData.push({
                      id: doc.id,
                      //AttendeeId: doc.id,
                      Name:
                        (doc.data().FirstName == undefined
                          ? ""
                          : doc.data().FirstName.trim()) +
                        " " +
                        (doc.data().LastName == undefined
                          ? ""
                          : doc.data().LastName.trim()),
                      FirstName:
                        doc.data().FirstName != undefined
                          ? doc.data().FirstName
                          : "",
                      LastName:
                        doc.data().LastName != undefined
                          ? doc.data().LastName
                          : "",
                      Email: doc.data().Email,
                      Tags: doc.data().Tags ? doc.data().Tags : "",
                      Phone:
                        doc.data().Phone != undefined ? doc.data().Phone : "",
                      Website:
                        doc.data().Website != undefined
                          ? doc.data().Website
                          : "",
                      HideInList: doc.data().HideInList
                        ? doc.data().HideInList
                        : false,
                      IsPublished:
                        doc.data().IsPublished != undefined
                          ? doc.data().IsPublished
                          : false,
                      Image: self.getCDNUrl(doc.data().ProfilePictureURL),
                      Company: doc.data().Company,
                      Designation: doc.data().Designation,
                      Profile:
                        doc.data().Profile == undefined
                          ? ""
                          : doc.data().Profile,
                      Resources: doc.data().Resources
                        ? doc.data().Resources
                        : [],
                      SocialLinks: doc.data().SocialLinks
                        ? doc.data().SocialLinks
                        : [],
                      Initials: common.getInitials(
                        (doc.data().FirstName == undefined
                          ? ""
                          : doc.data().FirstName.trim()) +
                          " " +
                          (doc.data().LastName == undefined
                            ? ""
                            : doc.data().LastName.trim())
                      ),
                      //ShowSearch: self.ShowSearch
                    });
                  }
                });
                // self.attendeeData.sort(function (a, b) {
                //   if (a.Name < b.Name) {
                //     return -1;
                //   }
                //   if (a.Name > b.Name) {
                //     return 1;
                //   }
                //   return 0;
                // });
              }
            })
            .catch((error) => {
              bus.$emit("toggleLoader", false);
              console.log(error);
              // console.log("Error getting documents: ", error);
            });
        } //else part of filter
      } //else part of search ENDS
    },

    getFilterList() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      try {
        db.collection(obj.eventcollectionname)
          .doc("SpeakerGroupList")
          .collection("SpeakerGroups")
          .get()
          .then((querySnapshot) => {
            self.spkFilterData = [];
            self.spkFilterData.push({
              id: "All",
              GroupName: "All",
            });
            querySnapshot.forEach((doc) => {
              self.spkFilterData.push({
                id: doc.data().GroupID,
                GroupName: doc.data().GroupName,
              });
            });
          });
      } catch (error) {
        console.log(error);
      }
    },
    searchAttendee2: function () {
      if (self.searchtext == "") {
        $("#dvAttendeeWrapper").html("");
        self.totalRecords = 1;
        self.firstPageCalled = false;
        self.pageIndex = 0;
        self.hasMore = true;
        lastVisible = null;
        self.attendeeData = [];

        self.displayAttendees();
      }
    },
    searchAttendee: function () {
      $("#dvAttendeeWrapper").html("");
      self.totalRecords = 1;
      self.firstPageCalled = false;
      self.pageIndex = 0;
      self.hasMore = true;
      lastVisible = null;
      self.attendeeData = [];

      self.displayAttendees();

      /*
      self.totalRecords = 1;
      self.firstPageCalled = false;
      self.pageIndex = 0;
      self.hasMore = true;
      self.lastVisible = null;
      self.attendeeData = [];

      setTimeout(function () {
        self.displayAttendees();
      }, 1000);*/
    },
    goToSession: function () {
      $("#dvBackDrop").hide();
      $("#myModal2").modal("hide");
      router.push({ path: "/sessions" });
    },
    DisplaySessionDetails(session) {
      self.sessionDetailsKey++;
      self.sessionDetailsPopup = true;
      //self.IsMyAgenda = self.mySessions.includes(session.SessionId)
      self.currentSession = session;
    },
    onChange(event) {
      self.tid = event.target.value;
      //console.log(self.tid);
      self.spkrFilter = self.tid;
      //self.displayRoundtable();
      self.displayAttendees();
    },

    //getInitials: function (str) {
    //  // console.log(str);
    //  //var str = "Java Script Object Notation";
    //  var matches = str.match(/\b(\w)/g); // ['J','S','O','N']
    //  var acronym = "";
    //  if (matches != null) {
    //    acronym = matches.join(""); // JSON
    //  }
    //  return acronym;
    //  //console.log(acronym);
    //},
    openModal: async function (
      attendeeid,
      Name,
      Company,
      Title,
      Image,
      profile,
      Initials,
      sLinks,
      Resources,
      Email,
      Attendee
    ) {
      self.requestMeetingKey++;
      self.currentAttendee = Attendee;
      if (Image) self.imageExists = true;
      else {
        self.imageExists = false;
      }
      //var flag = true;
      //if (flag) {
      //  return;
      //}
      //self.currentAttendee.Designation = Attendee.Title;
      self.currentAttendee.ProfilePictureURL = Attendee.Image;
      self.currentAttendee.AttendeeId = null;
      this.isBookmarked = false;
      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          eventName: this.$store.state.eventname,
          enetityUserId: this.$store.state.userId,
          attendeeId: this.$store.state.userId,
          entityType: 2,
          entityName: this.currentAttendee.Name,
          entityImage: this.currentAttendee.Image
            ? this.currentAttendee.Image
            : "",
          entityId: this.currentAttendee.id,
        },
      };

      // console.log(Resources);
      //document.getElementById("Session").innerText = "";
      if (Image) {
        $("#imgModalSpeakers").attr("src", Image);
        $("#imgModalSpeakerEnlarge").attr("src", self.getCDNUrl(Image));
        document.getElementById("dvImgeHldText").innerText = "";
        $("#dvImgeHldText").hide();
        $("#imgModalSpeakers").show();
        $("#dvImgeHld").show();
      } else {
        /*$("#imgModalSpeakers").attr(
          "src",
          "../assets/Images/new-attendee-img.jpg"
        );*/
        $("#imgModalSpeakers").attr("src", "");
        $("#imgModalSpeakers").hide();

        document.getElementById("dvImgeHldText").innerText = Initials;
        $("#dvImgeHldText").show();
        $("#dvImgeHld").hide();
      }
      this.requestorId = attendeeid;
      document.getElementById("modalReceiverId").innerText = attendeeid;
      document.getElementById("modalName").innerText = Name;
      document.getElementById("modalCompany").innerText = Company;
      document.getElementById("modalTtile").innerText = Title;
      document.getElementById("modalProfile").innerHTML = profile;
      document.getElementById("modalEmail").innerText = Email;

      //--------------Resource collection-------------------------------------------------------------
      document.getElementById("Resource").innerText = "";
      if (Resources != undefined) {
        if (Resources.length > 0) {
          if (Resources != "") {
            Resources.forEach((resource) => {
              $("#Resource").append(
                " <div class='session-tab-innerBox p-3 mb-2'><h5 class><a href=" +
                  resource +
                  '" target="_blank">' +
                  self.getFileName(resource) +
                  "</h5></div>"
              );
            });
            document.getElementById("ulTabList").children[2].style.display =
              "block";
          } else {
            document.getElementById("ulTabList").children[2].style.display =
              "none";
          }
        } else {
          document.getElementById("ulTabList").children[2].style.display =
            "none";
        }
        //  var resrceTabHeader = document.getElementById("liResourceTab");//
        // document.getElementById("ulTabList").children[2].style.display = "block";
        // resrceTabHeader.style.display = "block";
      } else {
        // var resrceTabHeader2 = document.getElementById("liResourceTab");
        // resrceTabHeader2.style.display = "none";
        // document.getElementById("ulTabList").children[2].style.display = "none";
        document.getElementById("ulTabList").children[2].style.display = "none";
      }
      // if (Resources.length <= 0) {
      //   // $("#Resource").attr.add("style", "display:none;");
      //   document.getElementById("ulTabList").children[2].style.display = "none";
      // } else {
      //   document.getElementById("ulTabList").children[2].style.display =
      //     "block";
      // }
      //-------------Session collection for Speaker-------------------------------------
      //var arrSession = [];
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      //console.log(obj.tzone);
      try {
        var listRef = db
          .collection(obj.eventcollectionname) //"OA_UAT_C1591205467009E1591206650065")
          .doc("SessionList")
          .collection("Sessions");
      } catch (error) {
        console.log(error);
      }
      self.speakersSessionList = [];
      listRef
        .orderBy("StartDate", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var objSession = doc.data();

            objSession.MappedSpeakers = doc.data().MappedSpeakers
              ? doc.data().MappedSpeakers
              : [];
            objSession.MappedHosts = doc.data().MappedHosts
              ? doc.data().MappedHosts
              : [];
            objSession.MappedCoHost = doc.data().MappedCoHost
              ? [doc.data().MappedCoHost]
              : [];

            $.each(objSession.MappedSpeakers, function (index, value) {
              if (value.AttendeeId == attendeeid) {
                // var obj = new Object();
                // obj.Name =
                //   doc.data().Name == undefined ? "" : doc.data().Name;
                // obj.StartDate =
                //   doc.data().StartDate == undefined
                //     ? ""
                //     : doc.data().StartDate;
                // obj.EndDate =
                //   doc.data().EndDate == undefined ? "" : doc.data().EndDate;
                // arrSession.push(obj);
                objSession.Name =
                  objSession.Name == undefined ? "" : objSession.Name;
                objSession.StartDate =
                  objSession.StartDate == undefined ? "" : objSession.StartDate;
                objSession.EndDate =
                  objSession.EndDate == undefined ? "" : objSession.EndDate;

                objSession.MappedSpeakers.forEach(function (item) {
                  if (item.AttendeeId == self.userid) {
                    objSession.IsSpeaker = true;
                  }
                  item.Name = item.Name ? item.Name : "";
                  item.NameInitial = common.getInitials(item.Name);
                  item.Company = item.Company ? item.Company : "";
                  item.Designation = item.Designation ? item.Designation : "";
                  item.ProfilePictureURL = item.ProfilePictureURL
                    ? item.ProfilePictureURL
                    : "";
                  // var spkrs = self.allSpeakers.filter(function (spkr) {
                  //   return item.AttendeeId == spkr.SpeakerId;
                  // });
                  // if (spkrs.length > 0) {
                  //   item.Profile = spkrs[0].Profile;
                  //   item.HideInList = spkrs[0].HideInList;
                  // }
                });
                objSession.MappedHosts.forEach(function (item) {
                  if (item.AttendeeId == self.userid) {
                    objSession.IsHost = true;
                  }
                  item.Name = item.Name ? item.Name : "";
                  item.NameInitial = common.getInitials(item.Name);
                  item.Company = item.Company ? item.Company : "";
                  item.Designation = item.Designation ? item.Designation : "";
                  item.ProfilePictureURL = item.ProfilePictureURL
                    ? item.ProfilePictureURL
                    : "";

                  // var spkrs = self.allSpeakers.filter(function (spkr) {
                  //   return item.AttendeeId == spkr.SpeakerId;
                  // });
                  // if (spkrs.length > 0) {
                  //   item.Profile = spkrs[0].Profile;
                  //   item.HideInList = spkrs[0].HideInList;
                  // }
                });
                objSession.MappedCoHost.forEach(function (item) {
                  if (item.AttendeeId == self.userid) {
                    objSession.IsHost = true;
                  }
                  item.Name = item.Name ? item.Name : "";
                  item.NameInitial = common.getInitials(item.Name);
                  item.Company = item.Company ? item.Company : "";
                  item.Designation = item.Designation ? item.Designation : "";
                  item.ProfilePictureURL = item.ProfilePictureURL
                    ? item.ProfilePictureURL
                    : "";
                  // var spkrs = self.allSpeakers.filter(function (spkr) {
                  //   return item.AttendeeId == spkr.SpeakerId;
                  // });
                  // if (spkrs.length > 0) {
                  //   item.Profile = spkrs[0].Profile;
                  //   item.HideInList = spkrs[0].HideInList;
                  // }
                });

                objSession.MappedSpeakers.sort(function (a, b) {
                  let aName = a.Name.trim().toLowerCase();
                  let bName = b.Name.trim().toLowerCase();
                  if (aName < bName) {
                    return -1;
                  }
                  if (aName > bName) {
                    return 1;
                  }
                  return 0;
                });
                objSession.MappedHosts.sort(function (a, b) {
                  let aName = a.Name.trim().toLowerCase();
                  let bName = b.Name.trim().toLowerCase();
                  if (aName < bName) {
                    return -1;
                  }
                  if (aName > bName) {
                    return 1;
                  }
                  return 0;
                });
                objSession.StartTime = objSession.StartDate.seconds;
                objSession.EndTime = objSession.EndDate.seconds;
                objSession.StartTimeLabel = self.getFormattedDateTime(
                  objSession.StartTime
                );
                objSession.EndTimeLabel = self.getFormattedDateTime(
                  objSession.EndTime
                );
                self.speakersSessionList.push(objSession);
              }
            });
          });
        });
      //-----------------------------------------------------------------------------------

      // $("#myModal2").addClass("show");
      // $("#myModal2").show();
      // $("#dvBackDrop").show();
      // $("#dvBackDrop").addClass("show");
      //--------------------------------------------------------------------------------
      //console.log("Facebook:- " + sLinks[0].Facebook);
      // console.log("Twitter:- " + sLinks[1].Twitter);
      // console.log("GooglePlus:- " + sLinks[2].GooglePlus);
      //console.log("LinkedIn:- " + sLinks[3].LinkedIn);
      $("#spnFacebook").hide();
      $("#spnTwitter").hide();
      $("#spnLinkedIn").hide();
      console.log(sLinks);
      var showFB = 0;
      var showTwitter = 0;
      var showLinkedIn = 0;

      $("#aBiography").attr("data-tag", "speaker- " + Name + "- Biography");
      $("#aSession").attr("data-tag", "speaker- " + Name + "- Session");
      $("#aResource").attr("data-tag", "speaker- " + Name + "- Resource");
      $("#btnOpenRequestMeeting").attr(
        "data-tag",
        "speaker- " +
          document.getElementById("modalName").innerText +
          " -OpenRequestMeeting"
      );
      $("#modalEmail").attr(
        "data-tag",
        "attendee-" +
          document.getElementById("modalName").innerText +
          "-" +
          Email
      );
      $("#btnShowSendMessageButton").attr("href", "mailto:" + Email);
      $("#btnShowSendMessageButton").attr(
        "data-tag",
        "speaker- " +
          document.getElementById("modalName").innerText +
          " -SendMessage"
      );

      sLinks.forEach((sLink) => {
        if (sLink["Facebook"] != undefined) {
          if (sLink["Facebook"] != "") {
            showFB++;
            if (sLink["Facebook"].includes("https://")) {
              document.getElementById("anchFacebook").href = sLink["Facebook"];
              $("#anchFacebook").attr(
                "data-tag",
                "speaker - " + Name + "-" + sLink["Facebook"]
              );
              $("#spnFacebook").attr(
                "data-tag",
                "speaker - " + Name + "-" + sLink["Facebook"]
              );
              $("#iFacebook").attr(
                "data-tag",
                "speaker - " + Name + "-" + sLink["Facebook"]
              );
            } else {
              document.getElementById("anchFacebook").href =
                "https://" + sLink["Facebook"];
              $("#anchFacebook").attr(
                "data-tag",
                "speaker - " + Name + "-" + sLink["Facebook"]
              );
              $("#spnFacebook").attr(
                "data-tag",
                "speaker - " + Name + "-" + sLink["Facebook"]
              );
              $("#iFacebook").attr(
                "data-tag",
                "speaker - " + Name + "-" + sLink["Facebook"]
              );
            }
          }
        }

        if (sLink["Twitter"] != undefined) {
          if (sLink["Twitter"] != "") {
            showTwitter++;
            if (sLink["Twitter"].includes("https://")) {
              document.getElementById("anchTwitter").href = sLink["Twitter"];
              $("#anchTwitter").attr(
                "data-tag",
                "Speaker - " + Name + "-" + sLink["Twitter"]
              );
              $("#spnTwitter").attr(
                "data-tag",
                "Speaker - " + Name + "-" + sLink["Twitter"]
              );
              $("#iTwitter").attr(
                "data-tag",
                "Speaker - " + Name + "-" + sLink["Twitter"]
              );
            } else {
              document.getElementById("anchTwitter").href =
                "https://" + sLink["Twitter"];
              $("#anchTwitter").attr(
                "data-tag",
                "Speaker - " + Name + "-" + "https://" + sLink["Twitter"]
              );
              $("#spnTwitter").attr(
                "data-tag",
                "Speaker - " + Name + "-" + "https://" + sLink["Twitter"]
              );
              $("#iTwitter").attr(
                "data-tag",
                "Speaker - " + Name + "-" + "https://" + sLink["Twitter"]
              );
            }
          }
        }

        if (sLink["LinkedIn"] != undefined) {
          if (sLink["LinkedIn"] != "") {
            showLinkedIn++;
            if (sLink["LinkedIn"].includes("https://")) {
              document.getElementById("anchLinkedIn").href = sLink["LinkedIn"];
              $("#anchLinkedIn").attr(
                "data-tag",
                "Speaker - " + Name + "-" + sLink["LinkedIn"]
              );
              $("#spnLinkedIn").attr(
                "data-tag",
                "Speaker - " + Name + "-" + sLink["LinkedIn"]
              );
              $("#iLinkedIn").attr(
                "data-tag",
                "Speaker - " + Name + "-" + sLink["LinkedIn"]
              );
            } else {
              document.getElementById("anchLinkedIn").href =
                "https://" + sLink["LinkedIn"];
              $("#anchLinkedIn").attr(
                "data-tag",
                "Speaker - " + Name + "-" + "https://" + sLink["LinkedIn"]
              );
              $("#spnLinkedIn").attr(
                "data-tag",
                "Speaker - " + Name + "-" + "https://" + sLink["LinkedIn"]
              );
              $("#iLinkedIn").attr(
                "data-tag",
                "Speaker - " + Name + "-" + "https://" + sLink["LinkedIn"]
              );
            }
          }
        }
      });
      if (showFB > 0) {
        $("#spnFacebook").show();
      }
      if (showTwitter > 0) {
        $("#spnTwitter").show();
      }
      if (showLinkedIn > 0) {
        $("#spnLinkedIn").show();
      }
      /*  if (sLinks[0].Facebook != undefined && sLinks[0].Facebook != "") {
        if (sLinks[0].Facebook.includes("https://")) {
          document.getElementById("anchFacebook").href = sLinks[0].Facebook;
        } else {
          document.getElementById("anchFacebook").href =
            "https://" + sLinks[0].Facebook;
        }
        $("#spnFacebook").show();
      } else {
        $("#spnFacebook").hide();
      }
      //--------------------------------------------------------------------------------------------------------
      if (sLinks[1].Twitter != undefined && sLinks[1].Twitter != "") {
        if (sLinks[1].Twitter.includes("https://")) {
          document.getElementById("anchTwitter").href = sLinks[1].Twitter;
        } else {
          document.getElementById("anchTwitter").href =
            "https://" + sLinks[1].Twitter;
        }
        $("#spnTwitter").show();
      } else {
        $("#spnTwitter").hide();
      }
      //---------------------------------------------------------------------------------------------------------
      if (sLinks[3].LinkedIn != undefined && sLinks[3].LinkedIn != "") {
        if (sLinks[3].LinkedIn.includes("https://")) {
          document.getElementById("anchLinkedIn").href = sLinks[3].LinkedIn;
        } else {
          document.getElementById("anchLinkedIn").href =
            "https://" + sLinks[3].LinkedIn;
        }

        $("#spnLinkedIn").show();
      } else {
        $("#spnLinkedIn").hide();
      }*/
      //---------------------------------------------------------------------------------------------

      this.postLeaderboardAction("SPVW");
      try {
        let bookmarkExists = await axios({
          method: "post",
          url: self.APIs.BookmarkAPIConfig.Get,
          data: rqstData,
        });
        if (bookmarkExists.data && bookmarkExists.data.isPublished)
          this.isBookmarked = true;
        else this.isBookmarked = false;
      } catch (e) {
        console.log(e);
        this.isBookmarked = false;
      }
    },
    getFormattedDateTime: function (seconds) {
      var dt = new Date(seconds * 1000);
      var day = dt.getDate();
      var month = dt.getMonth();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      var amPM = hours < 12 || hours == 0 ? "AM" : "PM";
      hours = hours > 12 ? hours - 12 : hours;
      hours = hours == 0 ? 12 : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      minutes = minutes == 0 ? "00" : minutes;
      var formattedtime =
        hours.toString() + ":" + minutes.toString() + " " + amPM;
      formattedtime = monthNamesShort[month] + " " + day + ", " + formattedtime;
      return formattedtime;
    },
    getFileName(downloadUrl) {
      let url = decodeURIComponent(downloadUrl);
      let arr = url.split("?");
      let arr2 = arr[0].split("/");
      let name = arr2[arr2.length - 1];
      return name;
    },
    scroll: function () {
      //window.onscroll = () => {
      if (!self.IsSearchMode) {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight + 1 >=
          document.documentElement.offsetHeight;
        if (bottomOfWindow) {
          if (self.searchtext.trim() == "") {
            //this.displayAttendees();
          }
          //this.AddAnalitics(event, "scroll");
        }
      }
      //};
    },
    exitmenu: function () {
      $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              this.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                this.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          this.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            this.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    onClickHandler() {
      // event.target is the clicked element object
      // this.AddAnalitics(event, "click");
    },
    OpenRequestMeeting() {
      if (!self.hasValidAuth({ auth_type: 1 })) {
        return;
      }
      self.currentAttendee.AttendeeId = self.currentAttendee.id;
      // $("#ReqMeeting .calendar-wrap").show();
      //    $("#ReqMeeting .modal-body-wrapper2").hide();
      //    $("#ReqMeeting .modal-body-wrapper3").hide();

      // //
      //if (document.getElementById("dvImgeHldText").innerText == "") {
      //  var AttendeeImgPath = document.getElementById("imgModalSpeakers").src;

      //  if (AttendeeImgPath != null && AttendeeImgPath != "") {
      //    document.getElementById("ReqAttendeeImage").src = AttendeeImgPath;
      //  }

      //  $("#ReqAttendeeImage").show();
      //  if (document.getElementById("ReqdivImgHldText")) {
      //    document.getElementById("ReqdivImgHldText").innerText = "";
      //    $("#ReqdivImgHldText").hide();
      //  }
      //} else {
      //  var Initials = document.getElementById("dvImgeHldText").innerText;
      //  $("#ReqAttendeeImage").attr("src", "");
      //  $("#ReqAttendeeImage").hide();
      //  if (document.getElementById("ReqdivImgHldText")) {
      //    document.getElementById("ReqdivImgHldText").innerHTML =
      //      "<h4>" + Initials + "</h4>";
      //    $("#ReqdivImgHldText").show();
      //  }
      //}

      // $("#hdnMSAttendeeId").val($("#hdnAttendeeId").val());
      //if (document.getElementById("ReqAttendeeName")) {
      //  document.getElementById("ReqAttendeeName").innerText =
      //    document.getElementById("modalName").innerText;
      //}
      //if (document.getElementById("ReqAttendeeNameh4")) {
      //  document.getElementById("ReqAttendeeNameh4").innerText =
      //    document.getElementById("ReqAttendeeName").innerText;
      //}
      //if (document.getElementById("ReqAttendeeTitle")) {
      //  document.getElementById("ReqAttendeeTitle").innerText =
      //    document.getElementById("modalTtile").innerText;
      //}
      //if (document.getElementById("ReqAttendeeCompany")) {
      //  document.getElementById("ReqAttendeeCompany").innerText =
      //    document.getElementById("modalCompany").innerText;
      //}
      //if (document.getElementById("modalEmail")) {
      //  if (document.getElementById("modalEmail").innerText !== "") {
      //    if (
      //      document
      //        .getElementById("modalEmail")
      //        .innerText.substring(
      //          document.getElementById("modalEmail").innerText.length,
      //          document.getElementById("modalEmail").innerText.length - 1
      //        ) !== "#"
      //    ) {
      //      document.getElementById("ReqAttendeeEmail").href =
      //        document.getElementById("modalEmail").innerText;
      //      if (
      //        document
      //          .getElementById("ReqAttendeeEmail")
      //          .href.indexOf("mailto") < 0
      //      ) {
      //        $("#ReqAttendeeEmail").text(
      //          document.getElementById("modalEmail").innerText
      //        );
      //        document.getElementById("ReqAttendeeEmail").href =
      //          "mailto:" + document.getElementById("ReqAttendeeEmail").href;
      //      }
      //      $("#ReqAttendeeEmail").parent().show();
      //    } else {
      //      $("#ReqAttendeeEmail").parent().hide();
      //    }
      //  } else {
      //    $("#ReqAttendeeEmail").parent().hide();
      //  }
      //}

      //if (document.getElementById("modalPhone")) {
      //  if (document.getElementById("modalPhone").innerText !== "") {
      //    if (
      //      document
      //        .getElementById("modalPhone")
      //        .innerText.substring(
      //          document.getElementById("modalPhone").innerText.length,
      //          document.getElementById("modalPhone").innerText.length - 1
      //        ) !== "#"
      //    ) {
      //      document.getElementById("ReqAttendeePhone").href =
      //        document.getElementById("modalPhone").innerText;
      //      if (
      //        document.getElementById("ReqAttendeePhone").href.indexOf("tel") <
      //        0
      //      ) {
      //        $("#ReqAttendeePhone").text(
      //          document.getElementById("modalPhone").innerText
      //        );
      //        document.getElementById("ReqAttendeePhone").href =
      //          "tel:" + document.getElementById("ReqAttendeePhone").href;
      //      }
      //      $("#ReqAttendeePhone").parent().show();
      //    } else {
      //      $("#ReqAttendeePhone").parent().hide();
      //    }
      //  } else {
      //    $("#ReqAttendeePhone").parent().hide();
      //  }
      //}

      //if (document.getElementById("modalWebsite")) {
      //  if (document.getElementById("modalWebsite").innerText !== "") {
      //    if (
      //      document
      //        .getElementById("modalWebsite")
      //        .innerText.substring(
      //          document.getElementById("modalWebsite").innerText.length,
      //          document.getElementById("modalWebsite").innerText.length - 1
      //        ) !== "#"
      //    ) {
      //      document.getElementById("ReqAttendeeWebsite").href =
      //        document.getElementById("modalWebsite").innerText;
      //      if (
      //        document
      //          .getElementById("ReqAttendeeWebsite")
      //          .href.indexOf("http") < 0
      //      ) {
      //        $("#ReqAttendeeWebsite").text(
      //          document.getElementById("modalWebsite").innerText
      //        );
      //        document.getElementById("ReqAttendeeWebsite").href =
      //          "http://" + document.getElementById("ReqAttendeeWebsite").href;
      //      }
      //      $("#ReqAttendeeWebsite").parent().show();
      //    } else {
      //      $("#ReqAttendeeWebsite").parent().hide();
      //    }
      //  } else {
      //    $("#ReqAttendeeWebsite").parent().hide();
      //  }
      //}

      if (
        document.getElementById("anchFacebook") &&
        document.getElementById("aFacebok") &&
        document.getElementById("anchFacebook").href !== ""
      ) {
        if (
          document
            .getElementById("anchFacebook")
            .href.substring(
              document.getElementById("anchFacebook").href.length,
              document.getElementById("anchFacebook").href.length - 1
            ) !== "#"
        ) {
          document.getElementById("aFacebok").href =
            document.getElementById("anchFacebook").href;
          if (document.getElementById("aFacebok").href.indexOf("http") < 0) {
            document.getElementById("aFacebok").href =
              "http://" + document.getElementById("aFacebok").href;
          }
          $("#aFacebok").show();
        } else {
          $("#aFacebok").hide();
        }
      } else {
        $("#aFacebok").hide();
      }

      if (
        document.getElementById("anchTwitter") &&
        document.getElementById("aTwitter") &&
        document.getElementById("anchTwitter").href !== ""
      ) {
        if (
          document
            .getElementById("anchTwitter")
            .href.substring(
              document.getElementById("anchTwitter").href.length,
              document.getElementById("anchTwitter").href.length - 1
            ) !== "#"
        ) {
          document.getElementById("aTwitter").href =
            document.getElementById("anchTwitter").href;
          if (document.getElementById("aTwitter").href.indexOf("http") < 0) {
            document.getElementById("aTwitter").href =
              "http://" + document.getElementById("aTwitter").href;
          }
          $("#aTwitter").show();
        } else {
          $("#aTwitter").hide();
        }
      } else {
        $("#aTwitter").hide();
      }

      if (document.getElementById("anchLinkedIn").href !== "") {
        if (
          document
            .getElementById("anchLinkedIn")
            .href.substring(
              document.getElementById("anchLinkedIn").href.length,
              document.getElementById("anchLinkedIn").href.length - 1
            ) !== "#"
        ) {
          document.getElementById("aLikedin").href =
            document.getElementById("anchLinkedIn").href;
          if (document.getElementById("aLikedin").href.indexOf("http") < 0) {
            document.getElementById("aLikedin").href =
              "http://" + document.getElementById("aLikedin").href;
          }
          $("#aLikedin").show();
        } else {
          $("#aLikedin").hide();
        }
      } else {
        $("#aLikedin").hide();
      }
      var senderId = this.requestorId;
      console.log("hdnattendeeId=====", senderId);
      var ComponentClass = Vue.extend(RequestMeeting);
      var instance = new ComponentClass({
        propsData: {
          attendeeId: this.requestorId,
          showDatePicker: true,
          attendee: this.currentAttendee,
        },
      });
      instance.$mount(); // pass nothing
      $("#myModal2").hide();
      $(".modal-backdrop").hide();
    },
    mob_spelist_search() {
      $("#mob_spe_search").css("display", "flex");
      $(".mob_search_button").css("opacity", "0 ");
    },
  },
};
</script>
